(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-quantity-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncQuantity(radioInput) {
    // 1. Quantity value lo radio se
    var qty = parseInt(radioInput.value, 10);
    if (isNaN(qty) || qty < 1) return;

    // 2. Quantity selector dhundho — same section ke andar
    //    (agar multiple products ho page par)
    var section = radioInput.closest('[data-section-id], form[id^="product-form-"]');
    var qtyInput;

    if (section) {
      qtyInput = section.querySelector('quantity-selector-component input[name="quantity"]');
    }

    // Fallback: page par pehla milne wala selector
    if (!qtyInput) {
      qtyInput = document.querySelector('quantity-selector-component input[name="quantity"]');
    }

    if (!qtyInput) return;

    // 3. Value set karo
    qtyInput.value = qty;

    // 4. Minus button: qty == min par disable karo
    var minVal = parseInt(qtyInput.getAttribute('min') || qtyInput.dataset.min || 1, 10);
    var qtySelector = qtyInput.closest('quantity-selector-component');

    if (qtySelector) {
      var minusBtn = qtySelector.querySelector('button[name="minus"]');
      var plusBtn  = qtySelector.querySelector('button[name="plus"]');

      if (minusBtn) minusBtn.disabled = qty <= minVal;
      if (plusBtn)  plusBtn.disabled  = false;
    }

    // 5. Native input event fire karo taaki Shopify/theme
    //    ka koi bhi listener (cart, price update) aware ho sake
    var nativeInputEvent = new Event('input',  { bubbles: true });
    var nativeChangeEvent = new Event('change', { bubbles: true });
    qtyInput.dispatchEvent(nativeInputEvent);
    qtyInput.dispatchEvent(nativeChangeEvent);
  }

  function attachListeners() {
    // Sabhi quantity-break radio inputs par listener lagao
    document.querySelectorAll('input[type="radio"][name="quantity"][data-input]').forEach(function (radio) {
      // Pehle se checked wala immediately sync karo
      if (radio.checked) syncQuantity(radio);

      radio.addEventListener('change', function () {
        if (this.checked) syncQuantity(this);
      });
    });
  }

  // DOM ready hone par attach karo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

  // Shopify theme editor live updates ke liye (section reload)
  document.addEventListener('shopify:section:load', function () {
    attachListeners();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
